import TitleIcon from './TitleIcon';

export default TitleIcon;
